import { RootState } from "@/store";
import { ErpFeatureKeys } from "../models/erpFeature";
import { useSelector } from "react-redux";

export const useErpFeatures = () => {
  return useSelector((state: RootState) => state.erpFeatures);
};

export const useFeatureEnabled = (feature: ErpFeatureKeys): boolean => {
  return (
    useSelector((state: RootState) => state.erpFeatures?.[feature]?.isEnabled) ||
    false
  );
};

export const useFeaturesEnabled = (features: ErpFeatureKeys[]): boolean => {
  const erpFeatures = useSelector((state: RootState) => state.erpFeatures);
  return features.every((feature) => erpFeatures?.[feature]?.isEnabled ?? false);
};

export const useFeatureParams = (
  feature: ErpFeatureKeys,
): Record<string, unknown> => {
  return (
    useSelector((state: RootState) => state.erpFeatures?.[feature]?.params) || {}
  );
};
